webpackJsonp([267695594480457],{

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Terms = function Terms() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "hero-subpage strong-overlay" },
	      _react2.default.createElement(
	        "div",
	        { className: "" },
	        _react2.default.createElement(
	          "div",
	          { className: "container container-1010" },
	          _react2.default.createElement(
	            "p",
	            { className: "p1" },
	            _react2.default.createElement(
	              "span",
	              { className: "s1" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Terms of Service"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Welcome to Swiss Monkey! The Swiss Monkey website and services are provided by Swiss Monkey, Inc. (\"Swiss Monkey\"). These terms of service (\"Terms of Service\") govern your (\"Your\" or \"You\") access to and use of the services and features available on Swiss Monkey's website located at www.swissmonkey.io and all related sub-domains, mobile versions, tools, and services or through downloadable applications that Swiss Monkey makes available to You (\"Website\"), including without limitation Swiss Monkey's platform for connecting professional offices and professional independent contractors (collectively, \"Services\"). These Terms of Service incorporate by reference our Privacy Policy\xA0as referenced in the Website from time to time. Access to the Website, use of Services, and referrals to Offices or Professionals are subject to these Terms of Service and the Swiss Monkey\xA0Privacy Policy\xA0available on the Website."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "PLEASE READ THESE TERMS OF SERVICE CAREFULLY, AS THEY CREATE A BINDING CONTRACT BETWEEN YOU AND Swiss Monkey. FURTHER, THESE TERMS OF SERVICE CONTAIN AN AGREEMENT TO ARBITRATE, WHICH REQUIRES THAT YOU AND Swiss Monkey ARBITRATE CERTAIN CLAIMS BY BINDING, INDIVIDUAL ARBITRATION INSTEAD OF GOING TO COURT AND LIMITS CLASS ACTION CLAIMS, UNLESS YOU OPT OUT OF THE AGREEMENT TO ARBITRATE AS DESCRIBED IN THE ARBITRATION SECTION (SEE SECTION \"AGREEMENT TO ARBITRATE\")."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li4" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Overview"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p5" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey is a dental network that provides facilitates connections between employers/professional offices (\u201COffices\u201D) seeking to fill open permanent or temporary positions (each, an \"Assignment\") to individuals with a professional degree or professional background, including without limitation dentists, dental assistants, hygienists, front desk staff, consultants, lab technicians and other, similarly qualified individuals (\"Professionals\"), as specified by Swiss Monkey from time to time. Professionals make available their professional skills to fulfill Assignment requests in exchange for compensation determined between Professionals and Offices, as discussed in more detail below. Offices and Professionals together are collectively referred to as \"Users\" and each individually as a \"User.\" You are agreeing to these Terms of Service as either an Office or a Professional and, in either case, as a User."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p5" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey provides information about available offices and professionals to help Offices connect with Professionals based on criteria and needs important to each of them.",
	              _react2.default.createElement(
	                "span",
	                {
	                  className: "Apple-converted-space" },
	                "\xA0 "
	              ),
	              "It is solely the responsibility and ability of the Office and Professional to decide whether to offer or accept an assignment or position.",
	              _react2.default.createElement(
	                "span",
	                {
	                  className: "Apple-converted-space" },
	                "\xA0 "
	              ),
	              "Swiss Monkey is a marketplace for Offices and Professionals to connect. Swiss Monkey does not employ or retain Professionals and Swiss Monkey does not provide professional services to Offices other than the marketplace Services set forth herein and does not guarantee the availability or of users. The Office is the party that contracts with the Professional to complete an Assignment. Swiss Monkey has no liability to any User with regards to the quality of the Professionals or whether any Office offers suitable Assignments for any Professional. "
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p6" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "MANY JURISDICTIONS HAVE LAWS PROTECTING CONSUMERS AND OTHER CONTRACT PARTIES, LIMITING THEIR ABILITY TO WAIVE CERTAIN RIGHTS AND RESPONSIBILITIES. WE RESPECT SUCH LAWS; NOTHING HEREIN SHALL WAIVE RIGHTS OR RESPONSIBILITIES THAT CANNOT BE WAIVED."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p7" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "To the extent permitted by law, (1) we make no promise as to the completeness, accuracy, availability, timeliness, propriety, security or reliability; (2) your access and use are at your own risk, and Swiss Monkey is provided \"AS IS\" and \"AS AVAILABLE\"; (3) we are not liable for any harm resulting from (a) user content; (b) user conduct, e.g. illegal conduct; (c) your Swiss Monkey use; or (d) our representations; (4) WE AND OUR OFFICERS, DIRECTORS, EMPLOYEES (\"CL ENTITIES\"), DISCLAIM ALL WARRANTIES & CONDITIONS, EXPRESS OR IMPLIED, OF MERCHANTABILITY, FITNESS FOR PARTICULAR PURPOSE, OR NON-INFRINGEMENT; (5) Swiss Monkey ENTITIES ARE NOT LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, OR ANY LOSS (E.G. OF PROFIT, REVENUE, DATA, OR GOODWILL); (6) IN NO EVENT SHALL OUR TOTAL LIABILITY EXCEED $100.00."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li4" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Acceptance of Terms"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p8" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "These Terms of Service are effective as of May 1, 2018 (\"Effective Date\"). Your continued use of the Website after the Effective Date confirms your unconditional agreement to the Terms of Service and Swiss Monkey's\xA0Privacy Policy\xA0regarding the Services provided by Swiss Monkey and use of the Website. Swiss Monkey reserves the right to update or modify these Terms of Service at any time by providing notice on the Website, and your use of this Website following any such change constitutes Your agreement to the revised Terms of Service from and after that date. An Office and a Professional are responsible for separately agreeing to the terms of the Assignment to be provided by a Professional."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li4" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Scope of Services"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p8" },
	            _react2.default.createElement(
	              "span",
	              {
	                className: "s2" },
	              "Swiss Monkey maintains the Website and mobile applications (\u201CPlatform\u201D) as a service to its visitors, subject to these Terms of Service. You are responsible for obtaining any equipment and Internet service necessary to access the Website and for paying any fees for the equipment and services you select. Swiss Monkey may alter, suspend or discontinue its Platform or the Services provided herein, in whole or in part, at any time and for any reason, without providing notice to you. The Website may also periodically become unavailable due to maintenance or malfunction of computer equipment or for other reasons including, without limitation, poor cellular network coverage or cellular network failure. Swiss Monkey may provide access to third party services and products, or to Swiss Monkey's products or services, from time to time, through the Platform. You acknowledge that the Platform is evolving and that the form and nature of the Platform, including the Services accessible via the Platform, may change from time to time without notice to you."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li9" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Access and Use Terms"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Personal Identifiable Information"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "You may use this Platform as a member of the Swiss Monkey network. You may be required to release personally identifiable information to register with Swiss Monkey so that you can more readily connect with other users. The information that You must disclose in order to register may include, without limitation, Your name and address, e-mail address, telephone number, position, recent photographs, geographical location, and billing information, and such other information as determined by Swiss Monkey from time to time such as your professional licensure and the results of any background check (\"User Information\"), which will be stored under Your [\"Account(s)\" (or \"Profile(s)\")] page."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Login Credentials"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "You agree that you are solely responsible for protecting Your Login Credentials from unauthorized use, maintaining the confidentiality of Your Account and password, and you agree to accept responsibility for all activities that occur under Your Login Credentials. You agree to notify us immediately if you believe that any of Your Login Credentials has been or may be used without your permission so that appropriate action may be taken. You may not (i) create more than one account to access the Website, (ii) share Your Login Credentials with any third party, or (iii) transfer your account to any third party."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey is not responsible for any loss or damage caused by, or expense incurred by, you as a result of your failure to safeguard Your Login Credentials. You agree that you shall not rent, resell, or remarket the Services or provide access to the Website to any third party. Swiss Monkey reserves the right to delist any Assignment from the Website, at any time and in Swiss Monkey's sole discretion. Swiss Monkey may terminate Your Account at any time at Swiss Monkey's sole discretion and with no liability to you. For example, but without limitation, Swiss Monkey may terminate Your Account if you violate these Terms of Service or Swiss Monkey's policies, or otherwise harm Swiss Monkey's business interests. You may not be entitled to create a new Account to access the Website if Swiss Monkey has terminated your prior Login Credentials. Swiss Monkey may also prohibit certain Users from re-registering with the Website, at Swiss Monkey's sole discretion."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Privacy; Rights in Your Data"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "You hereby represent and warrant to Swiss Monkey that (i) any User Information or other information relating to soliciting, offering, providing, or completing Assignments, as submitted to Swiss Monkey or the Website, including without limitation User Information, is true and correct and (ii) You have the right to provide any and all of the User Information or other information listed in Your Profile (collectively, \"Your Information\") for the purposes of these Terms of Service. You hereby grant to Swiss Monkey a perpetual, irrevocable, royalty-free, worldwide right and license to copy, display, make derivative works of and otherwise use Your Information for any purpose, subject in all respects to Swiss Monkey's\xA0Privacy Policy. If you object to Your Information being used in a manner permitted by these Terms of Service or the\xA0Privacy Policy, please do not use the Website or our Services. Upon termination of Your Login Credentials for any reason, you may no longer have access to any of Your Information that you provided to the Website."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Background Checks"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "If you are a Professional, Swiss Monkey has the right, but not the obligation, to verify whether the information displayed in Your Profile is accurate. If You are a Professional, You hereby grant to Swiss Monkey the right to conduct background checks on behalf of any Offices with which you may obtain Assignments through Swiss Monkey to confirm the accuracy of any User Information that is available on Your Profile including without limitation Your name and address, e-mail address, telephone number, photographs, geographical location, billing information, Your degree-granting program(s) and year(s) of graduation, any Assignment experience, any other of Your qualifications, Your credit score and a criminal background check of You (collectively, \"Background Checks\"). PROFESSIONAL HEREBY GRANTS TO Swiss Monkey THE RIGHT TO CONDUCT A CREDIT CHECK AND A CRIMINAL BACKGROUND CHECK BY REGISTERING WITH THE WEBSITE UPON RECEIVING YOUR EXPLICIT WRITTEN OR ELECTRONIC CONSENT. PROFESSIONAL AGREES AND ACKNOWLEDGES THAT Swiss Monkey RESERVES THE RIGHT TO DISTRIBUTE RESULTING INFORMATION, AS SET FORTH IN THIS PARAGRAPH, TO INTERESTED OFFICES POTENTIALLY SEEKING ASSIGNMENTS FROM YOU. For the avoidance of doubt, Swiss Monkey is under no obligation to conduct Background Checks on Professional, but Swiss Monkey may conduct a Background Check when a Professional first registers with Swiss Monkey or from time to time thereafter as long as such Professional maintains an account with Swiss Monkey."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Usage by Minors"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey's Services are available only to, and may only be used by, individuals who are 18 years and older who can form legally binding contracts under applicable law. Individuals under the age of 18 can use its Services only in conjunction with and under the supervision of a parent or legal guardian. In such a case, the adult is the User and is responsible for any and all activities of the minor."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Non-Performance or Incomplete Performance of Assignments"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "In the event that a Professional does not perform an Assignment at all or does not perform an Assignment in its entirety and in either case has not provided sufficient advance notice of such non-performance or incomplete performance as agreed to by such Professional and the affected Office or reasonable notice in the absence of such an agreement, the affected Office may notify Swiss Monkey. Swiss Monkey shall include information on such non-performance or incomplete performance of Assignments in Ratings for Professionals. Swiss Monkey reserves the right to institute other sanctions from time to time, and may, in Swiss Monkey's sole discretion, terminate the account of any Professional that repeatedly does not perform Assignments or does not completely perform Assignments that such Professional has agreed to perform without providing sufficient advance notice. For the avoidance of doubt, any information on non-performance or incomplete performance of Assignment in Ratings for Professionals shall be construed as an evaluation of such Professional by the relevant Office and not by Swiss Monkey."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "In the event that an Office cancels an Assignment and has not provided sufficient advance notice as agreed to by such Office and the affected Professional(s) or reasonable notice in the absence of such an agreement, the affected Professional(s) may notify Swiss Monkey. Swiss Monkey shall include information on such cancellation of Assignments in its Ratings for Offices. Swiss Monkey reserves the right to institute other sanctions from time to time, and may, in Swiss Monkey's sole discretion, terminate the account of any Office that repeatedly cancels Assignments that such Office has requested without providing sufficient advance notice."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li7" },
	              _react2.default.createElement(
	                "span",
	                { className: "s6" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "SALES."
	                ),
	                "\xA0You authorize us to charge your account for Swiss Monkey recurring annual or monthly membership fees. Other services such as concierge services, temp services, social media packages, admin/set up fees, and such may be billed separately upon a verbal agreement with the user. Services are recurring, unless otherwise noted. To cancel subscriptions, memberships or services, please contact the company. Unless noted, fees are in US dollars; tax is additional. To the extent permitted by law, fees are nonrefundable, even for posts we remove. We may refuse purchases, which may place a hold on your account."
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "s6" },
	                "Visa, MasterCard, and American Express are accepted."
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "li4" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "SwissMonkey.io is a Marketplace for Offices and Professionals"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p5" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey is a dental job and communications platform to facilitate connections between Offices seeking Professionals for the completion of permanent and temporary assignments. Swiss Monkey will use good faith efforts to help connect Offices to Professionals based on the nature of the Assignment, criteria and qualifications of the Office and Professional as well as geographic proximity to the Assignment. Swiss Monkey disclaims any responsibility for selecting particular Professionals to perform Assignments and Office understands and agrees that the decision to use any Professional or no Professional is solely Office's. Swiss Monkey disclaims all responsibility for the accuracy of any information listed in a Professional's Profile, for any information or material circumstances, and for any Profile information upon which Swiss Monkey may rely in connecting Offices to Professionals. Office agrees and acknowledges that Office has no obligation to choose Professionals to perform Assignments, and that Office's decision to contract with a Professional is solely at Office's own risk."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p8" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey does not take part in the interaction between Offices and Professionals. Swiss Monkey does not have control over the quality, timing, legality, failure to provide, or any other aspect whatsoever of any Assignments delivered by Professionals, nor of the integrity, responsibility or any of the actions or omissions whatsoever of any Users. Swiss Monkey makes no representations about the suitability, reliability, timeliness, or accuracy of the Assignments requested and provided by Users identified through Swiss Monkey whether in public, private or offline interactions. Swiss Monkey cannot confirm that Users are who they claim to be. Swiss Monkey does not assume any responsibility for the accuracy or reliability of this information or any information exchanged between Users through Swiss Monkey. SWISS Monkey IS NOT ABLE TO PROVIDE ANY ASSURANCES REGARDING THE TRUSTWORTHINESS OF PROFESSIONALS OR OFFICES AND THE INFORMATION THEY PROVIDE VIA Swiss Monkey\u2019s PLATFORM. WHEN INTERACTING WITH OTHER USERS YOU SHOULD EXERCISE CAUTION AND COMMON SENSE TO PROTECT YOUR PROPERTY AND WORK ENVIRONMENT, JUST AS YOU WOULD WHEN INTERACTING WITH OTHER PERSONS WHOM YOU DO NOT KNOW. NONE OF Swiss Monkey, Swiss Monkey\u2019s AFFILIATES OR LICENSORS IS RESPONSIBLE FOR THE CONDUCT, WHETHER ONLINE OR OFFLINE, OF ANY USER OF Swiss Monkey\u2019s SERVICES. Swiss Monkey, Swiss Monkey\u2019s AFFILIATES AND Swiss Monkey\u2019s LICENSORS WILL NOT BE LIABLE FOR ANY CLAIM, INJURY OR DAMAGE ARISING IN CONNECTION WITH YOUR USE OF THE SERVICES."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li9" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Intellectual Property Rights; Restrictions"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Platform and Content"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "You agree and acknowledge that the Platform and Content, including without limitation all of the content on the Platform, including without limitation the images, graphics, information, text, Ratings, data, links, as well as the underlying software, network and systems that support this Platform and Services and other material accessible through the Platform or Services (\"Content\") is solely and exclusively owned by or under license to Swiss Monkey and is protected by applicable trademark, copyright, or other rights. As such, You agree that You shall not (1) create or operate any platform, site or business that is based in whole or in part on this Platform, (2) copy, reproduce, modify, create derivative works, publish, distribute, transmit, publicly display or post on any other website or to any third party any Content without the prior written consent of Swiss Monkey on a case by case basis, or (3) reverse engineer, decompile, disassemble, modify, distribute, reproduce, republish or sell in any form or by any means, in whole or in part, any of the Content, (4) use a spider, web crawler or similar method to copy or extract Content. Subject to Your compliance with these Terms of Service, Swiss Monkey hereby grants to you a non-transferable, non-sublicensable, non-exclusive, revocable, and limited right to access and use the Platform and its Content solely for your internal business purposes as an Office or personal use as a Professional."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "The Content may contain typographical errors, other inadvertent errors, or inaccuracies. Swiss Monkey reserves the right to make changes to document names and content, descriptions or specification, or other information, without obligation to issue any notice of such changes."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "You may view, copy, download, and print Content that is available on this Platform or through the Services, subject to the following conditions:"
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "ol",
	                { className: "ol3" },
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You may only use the Content for internal informational purposes in compliance with all laws and regulations that apply to you. You may not reproduce or transmit any part of this Website or it\u2019s Content in any form, by any means, electronic or mechanical, including photocopying and recording for any other purpose."
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You may not modify, alter, or prepare derivative Assignments based on the Content, or distribute copies of or publicly perform or display the Content, including without limitation by posting the Content on any network computer or distributing the Content on or in any media."
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You may not remove copyright, trademark, and other proprietary notices from the Content."
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Nothing contained within this Website should be construed as granting, by implication, estoppel, or otherwise, any license or right to use this Website or any Content displayed on this Website, except: (a) as expressly permitted by these Terms of Service; or (b) with Swiss Monkey's prior written permission or the permission of the third party that owns the trademark or copyright of the Content displayed on this Website"
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Content Ownership and License"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey does not claim ownership of any Content submitted by Users. By submitting such Content, however, you hereby grant Swiss Monkey a world-wide, royalty-free, perpetual, irrevocable, non-exclusive license to use, distribute, reproduce, modify, adapt, create derivative works from, publicly perform and/or display such Content, subject to the restrictions set forth in these Terms of Service or the Privacy Policy. This license shall remain in effect until Swiss Monkey deletes the Content from Swiss Monkey's systems."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Copyright Infringement; Notice and Take Down Procedures"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "If you believe that any Content on this Website infringes your copyright, you may request that such Content be removed. This request must bear a signature (or electronic equivalent) of the copyright holder or an authorized representative and must include the following information:"
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "ol",
	                { className: "ol3" },
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "identification of the copyrighted work that You believe to be infringed, including a description of the work and, where possible, a copy or the location of an authorized version of the work;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "identification of the Content that You believe to be infringing and its location, including a description of the Content, and its Website location or other pertinent information that will help Swiss Monkey to locate such Content;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Your name, address, telephone number and email address;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "a statement that You have a good faith belief that the complained of use of the material is not authorized by the copyright owner, its agent, or the law;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      className: "s2" },
	                    "a statement that the information in Your claim is accurate; and"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "A statement that \"under penalty of perjury,\" You declare that you are the lawful copyright owner or are authorized to act on the owner's behalf."
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey's agent for copyright issues relating to this Website is: c/o Swiss Monkey Inc, 1816 L Street, Sacramento, CA 95811. In an effort to protect the rights of copyright owners, Swiss Monkey maintains a policy for the termination, in appropriate circumstances, of Users of this Website who are repeat infringers."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey reserves the right to terminate and/or temporarily disable the accounts of Users who repeatedly infringe the intellectual property rights, including without limitation copyrights, of others."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li9" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Prohibited Conduct"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "No Interference with The Website"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "You shall not disturb or interfere with the operation of the Website in any manner including without limitation by imposing an unreasonable or disproportionate burden on the network, software or hardware infrastructure of the Website."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "No Manipulation"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "You are prohibited from manipulating, by any means, the price of any Services offered on the Website (including without limitation through the use of an alias or decoys or by placing false offers for the sale or purchase of Assignments). Furthermore, you shall not disrupt or otherwise interfere in any way with another User's participation on the Website."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "No Unauthorized Conduct"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "In connection with your accessing the Website, Services, or Swiss Monkey's online messaging service, Rating system, or any other Service provided through the Website, You shall abide by the following standards of conduct. You shall not, and will not authorize or facilitate any attempt by another person, to use the Website or any messaging service, Ratings system or other Service to:"
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "ol",
	                { className: "ol3" },
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Transmit any Content that is unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, offensive, obscene, pornographic, lewd, lascivious, or otherwise objectionable, as determined by Swiss Monkey;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Circumvent or manipulate Swiss Monkey's fee structure, the billing process, or fees owed to Swiss Monkey or to the Professional;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Manipulate the price of any Assignment or interfere with other Users' Assignments;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Use a name or language that Swiss Monkey, in its sole discretion, deems offensive;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Post false, inaccurate, misleading, defamatory, or libelous content (including without limitation personal information);"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      className: "s2" },
	                    "Post hateful or racially or ethnically objectionable Content;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Post Content which infringes another's copyright, trademark or trade secret;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Post unsolicited advertising or unlawfully promote products or services;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Take any action that may undermine the Ratings system when it becomes available (such as displaying, importing or exporting Ratings information off of the Website or using it for purposes unrelated to Swiss Monkey);"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Harass, threaten or intentionally embarrass or cause distress to another User or entity;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Impersonate another User;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Exploit children under 18 years of age;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Engage in disruptive activity such as sending multiple messages in an effort to monopolize a messaging forum;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Introduce viruses, worms, Trojan horses and/or harmful code into the Website;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Obtain unauthorized access to any computer system or Confidential Information through the Website;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Transfer Your Swiss Monkey Profile (including Ratings) and Login Credentials to another party without Swiss Monkey's consent;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Harvest or otherwise collect information about Users, including email addresses, without their consent;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Invade the privacy of any person, including without limitation posting personally identifying or otherwise private information about a person without their consent (or their parent's consent in the case of a child under 18 years of age);"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Solicit personal information from children under 18 years of age;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Violate any federal, state, local, or international law or regulation; or"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li3" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "Encourage conduct that would constitute a criminal or civil offense."
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "li4" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Confidentiality"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p8" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "You shall not use or disclose any proprietary or confidential information with which you obtain or otherwise gain access to as a result of your access to or usage of the Platform or Services. All information regarding an Assignment between the Professional and an Office who sent such Assignment, whether or not in writing, of a private, secret or confidential nature concerning the Office's business or financial affairs (collectively, \"Proprietary Information\") is and shall be the exclusive property of such Office. By way of illustration, but not limitation, Proprietary Information may include the contents of an Assignment, products, product improvements, product enhancements, processes, methods, techniques, negotiation strategies and positions, projects, developments, plans (including business and marketing plans), research data, financial data (including sales costs, profits, pricing methods), personnel data, computer programs (including software used pursuant to a license agreement), customer, prospect and supplier lists, and contacts at or knowledge of customers or prospective customers of the Office, and patient medical or dental records and You will not disclose any Proprietary Information to any person or entity other than the applicable Office or use the same for any purposes (other than in the performance of Your duties as stipulated in the Assignment) without written approval by an officer of such Office, unless and until such Proprietary Information has become public knowledge without Your fault. While fulfilling the obligations of an Assignment for the Office, a Professional will use his/her best efforts to prevent unauthorized publication or disclosure of any of the Office's Proprietary Information. Professional agrees that all files, documents, letters, memoranda, reports, records, data, sketches, drawings, models, program listings, computer equipment or devices, computer programs or other written, photographic, or other tangible or intangible material containing Proprietary Information, whether created by such Professional or others, which shall come into his/her custody or possession, shall be and are the exclusive property of Office to be used by Professional only in the performance of his/her duties for the Office and shall not be copied or removed from Office's premises except in the pursuit of the business of Office as required to perform an Assignment. Swiss Monkey may require you to agree to an additional non-disclosure agreement prior to sharing certain other information with you. Any such non-disclosure agreement between you and Swiss Monkey shall apply to information shared in connection with the Website or Services, unless otherwise provided in such non-disclosure agreement."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li9" },
	              _react2.default.createElement(
	                "span",
	                {
	                  className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Relationships Among Professional, Office and Swiss Monkey"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Status as Professional"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "User agrees and acknowledges that he is not an employee or contracted with Swiss Monkey. User has the sole discretion to determine whether to accept or reject an assignment. Professional will be acting as an independent professional and nothing in these Terms of Service will be construed as creating an independent contractor, partnership, joint venture, or employer-employee relationship, nor will Professional be construed as Swiss Monkey's or an Office's employee, agent, franchisee or servant. "
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey disclaims any responsibility for determining whether a Professional is an independent contractor or employee of Office, and in the event that such a dispute arises between Office and Professional, Office and Professional are responsible for determining the status of Professional under applicable law or regulation."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Professional-Specific Representations"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              {
	                className: "s2" },
	              "If and to the extent that you use the Website as a Professional:"
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "ol",
	                { className: "ol3" },
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You acknowledge and agree that in any matter relating to your performance under these Terms of Service, including without limitation your obligations with respect to Swiss Monkey and any Offices for whom you perform Assignments or offer to perform Assignments, You will be solely responsible for all costs incurred by you. You shall not hold yourself out as having authority to make contracts or promises on behalf of any other party."
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You represent and warrant to Swiss Monkey that, for the Assignment that You offer to complete for an Office, You have the right to provide such an offer and that You are capable of performing and fit for performing any offers for Assignments that You provide hereunder;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You represent and warrant to Swiss Monkey and to any Office with which You perform Assignments that You have all necessary licenses, professional experience and legal qualifications to perform the Assignments that You agree to do and You maintain a valid insurance policy commensurate with industry standards, to remain in effect during and through the time that You act as an independent contractor;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You represent and warrant to Swiss Monkey and to any Office with which You perform Assignments that You will identify yourself as an independent, free standing contractor (not contracted with Swiss Monkey) of each Office with which You perform Assignments;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You covenant to Swiss Monkey and to any Office with which You perform Assignments that You will comply with the Health Information Portability and Accountability Act and all applicable associated rules and regulations, as may be amended from time to time, as well as all other applicable laws, rules and regulations;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You acknowledge and agree that Swiss Monkey may display advertisements on the Platform or in connection with Your Profile without any payment obligation to You;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You agree to honor the commitment You make to Offices via the Website; and"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You further acknowledge and agree that you will comply with all applicable state, federal, and international laws in performing Assignments."
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li3" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You understand that as a free standing agent you may not be covered by the Office's workers' compensation insurance policy. You agree and acknowledge that you are solely responsible for providing your own workers' compensation insurance coverage for temporary assignments and you have no expectation of coverage under the Office's coverage."
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Office-Specific Representations"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "If and to the extent you use the Website as an Office:"
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "ol",
	                { className: "ol3" },
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You agree to honor the commitments You make to Professionals via the Website;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You represent and warrant to Swiss Monkey that You are allowed to make purchasing decisions on behalf of Yourself or for the person or entity You represent, and that You will only request Assignments and place orders for Assignments that You have been authorized to request by such person or entity;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You covenant to Swiss Monkey and to any Professional who performs Assignments for You that You will comply with the Health Information Portability and Accountability Act and all applicable associated rules and regulations, as may be amended from time to time, as well as all other applicable laws, rules and regulations;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You represent and warrant to Swiss Monkey, and to any Professional who provides You with Assignments, that any agreements to provide Assignments do not conflict with any agreements You have with third parties and You further covenant that any agreements for You to retain Professional to perform Assignments will not conflict with any agreements You have with third parties;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You acknowledge and agree that Swiss Monkey may display advertisements on the Website or in connection with Your Profile without any payment obligation to You;"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li2" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You acknowledge and agree that Swiss Monkey disclaims all responsibility for providing You with any specific volume of Professionals to handle Assignments that you post to our Website; and"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "li3" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s2" },
	                    "You further acknowledge and agree that You will comply with all applicable state, federal, and international laws, and assume all responsibility for making payments related to social security, unemployment insurance, disability insurance, or worker's compensation insurance."
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "li9" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Rating System; Online Messaging System; Electronic Communications"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Ratings"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey may offer an online rating system as a determined by Swiss Monkey. As a User of the Website, You agree and acknowledge that you may have the ability to rate the performance of Counterparties whom with you transact business, and you understand that the Counterparties may rate your performance (collectively or individually, \"Ratings\") on the Website as well. Professionals may be rated on various parameters including without limitation the quality of the Assignment performed, timeliness and professionalism. Offices may be rated on various parameters including without limitation payment history and professionalism. Swiss Monkey will not release Users' Ratings for the viewing of the general public or for any Users that have not registered with the Website. Users can access Ratings only if and when Swiss Monkey provides Ratings as part of the information that a User is looking for in deciding to engage with a Counterparty. Any Ratings that are provided by Counterparties are solely the evaluation or rating of such Counterparty. Swiss Monkey disclaims any responsibility for the accuracy or quality of any Ratings."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "User acknowledges and agrees that Swiss Monkey reserves the right, without prior notice and in its sole discretion, to decide whether the content of Ratings violate these Terms of Service for any reason. If Swiss Monkey believes that Your Ratings contain inappropriate Content, Swiss Monkey may remove the Content of such Ratings, in whole or in part, and/or terminate your access to Swiss Monkey's Services. Swiss Monkey reserves the right to remove any Ratings, in whole or in part, from Swiss Monkey's Website at any time and its Swiss Monkey's sole discretion. If the content of such Ratings are found to be defamatory or legally actionable in a court of law, the User(s) responsible for posting such content will be held exclusively responsible, and Swiss Monkey will bear no responsibility."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Online Messaging System"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey may offer an online messaging system, as determined by Swiss Monkey from time to time. Users shall use such messaging system as permitted herein."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Responsibility for Ratings"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey is not responsible or liable for the conduct of Users or for views, opinions and statements expressed in Content submitted for public display through its Website, such as through an online messaging system, or for Content that is privately displayed to registrants of the Website, such as Ratings of Offices and Professionals. Swiss Monkey does not prescreen information exchanged in online messaging systems or listed in Office and Professional Ratings. With respect to such messaging systems and Ratings systems, Swiss Monkey acts as a passive conduit for distribution and Swiss Monkey is not responsible for the Content contained therein. Any opinions, advice, statements, services, offers, or other information in Content expressed or made available by Users of an online messaging system or Ratings system are those of the respective author(s) or distributor(s) and not of Swiss Monkey. Swiss Monkey neither endorses nor guarantees the accuracy, completeness, or usefulness of any such Content. Swiss Monkey is responsible for ensuring that Content submitted to this Website is not provided in violation of any copyright, trade secret or other intellectual property rights of another person or entity. You shall be solely liable for any damages resulting from infringement of copyrights, trade secret, or other intellectual property rights, or any other harm resulting from your uploading, posting or submission of Content to this Website."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Monitoring"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey has the right, but not the obligation, to monitor Content submitted to the Website through an online messaging or Rating system to assess compliance with these Terms of Service and any other applicable rules that Swiss Monkey may establish. Swiss Monkey has the right in Swiss Monkey's sole discretion to edit or remove any material submitted to or exchanged in any online messaging system or Ratings system provided through this Website. Without limiting the foregoing, Swiss Monkey has the right to remove any material that Swiss Monkey, in its sole discretion, finds to be in violation of these Terms of Service or otherwise objectionable, and You are solely responsible for the Content that You post to this Website."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Consent to Electronic Communications"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "You consent to receiving all documents, agreements and other communications (collectively, \"Communications\") from Swiss Monkey electronically. Swiss Monkey may make Communications available via its methods for contacting you on the Website or through an email address that you provide to Swiss Monkey. Communications may include without limitation information on Assignments or acceptance of offers for Assignments, updates to Swiss Monkey's Terms of Service or Privacy Policy, statements related to your account and other information that Swiss Monkey may provide from time to time. To receive such Communications, You may need certain hardware and software, as specified by Swiss Monkey from time to time. If you would like to receive a written copy of Communications, You acknowledge that there may be a delay in providing you with a copy, you must have provided Swiss Monkey with an accurate physical address, and you agree to pay the reasonable fees assessed by Swiss Monkey for delivering you such Communications to a physical address specified by you."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "If your email address becomes invalid or electronic Communications are otherwise returned to Swiss Monkey, Swiss Monkey reserves the right to terminate your account."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li13" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Some Information About Swiss Monkey "
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "li3" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                "You can reach Swiss Monkey with any questions as follows:\xA0",
	                _react2.default.createElement("br", null),
	                "Swiss Monkey, Inc",
	                _react2.default.createElement("br", null),
	                "1816 L Street",
	                _react2.default.createElement("br", null),
	                "Sacramento, CA 95811",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "mailto:contact@swissmonkey.io" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "s9" },
	                    "contact@swissmonkey.io"
	                  )
	                ),
	                _react2.default.createElement("br", null),
	                "(916) 500-4125"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "li4" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Disclaimer of Warranties"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p5" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey disclaims all responsibility for any interactions, correspondences, transactions, and other dealings that you have with any third parties including without limitation Offices or Professionals found on or through the Platform (including on or via linked websites or advertisements). Any such interactions, correspondences, transactions, and other dealings are solely between you and the third party (including without limitation issues related to the content of third party advertisements, payments, delivery of Assignment or Services). Under no circumstances will Swiss Monkey be responsibility for any loss or damage caused by your reliance on information in any Content on this Platform. It is your responsibility to evaluate the accuracy, completeness or usefulness of any information, opinion, advice or other content available through this Platform. You are responsible for seeking the advice of professionals, as appropriate, regarding the evaluation of any specific information, opinion, advice or other Content."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p5" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "YOU ACKNOWLEDGE THAT THE Platform AND ALL SERVICES, TEXT, IMAGES, AND OTHER INFORMATION ON OR ACCESSIBLE FROM THIS Platform ARE PROVIDED \"AS IS\" AND ARE BASED IN PART ON ASSIGNMENTS, OR OFFERS FOR ASSIGNMENTS, PROVIDED BY OFFICES, AND INFORMATION ABOUT PROFESSIONALS, WHICH ARE NOT OR MAY NOT BE VERIFIED BY Swiss Monkey, AND THAT ANY ASSIGNMENT ESTABLISHED THROUGH THE USE OF THE PLATFORM IS AT YOUR SOLE RISK AND DISCRETION. Swiss Monkey, Swiss Monkey\u2019s SUPPLIERS AND Swiss Monkey\u2019s LICENSORS ARE NOT LIABLE OR RESPONSIBLE FOR ANY RESULT GENERATED THROUGH THE USE OF THE PLATFORM EXCEPT AS SET FORTH IN THIS SECTION 15, Swiss Monkey PROVIDES NO OTHER WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. SPECIFICALLY, BUT WITHOUT LIMITATION, NONE OF Swiss Monkey, ITS AFFILIATES OR LICENSORS WARRANT THAT: (I) THE INFORMATION AVAILABLE ON THIS PLATFORM IS FREE OF ERRORS; (II) THE FUNCTIONS OR SERVICES (INCLUDING BUT NOT LIMITED TO MECHANISMS FOR THE DOWNLOADING AND UPLOADING OF CONTENT) PROVIDED BY THIS PLATFORM WILL BE UNINTERRUPTED, SECURE, OR FREE OF ERRORS; (III) DEFECTS WILL BE CORRECTED, OR (IV) THIS PLATFORM OR THE SERVER(S) THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p5" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "WITHOUT LIMITING THE FOREGOING, NONE OF Swiss Monkey, ITS AFFILIATES OR LICENSORS MAKE ANY WARRANTY AS TO THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICE, OR AS TO THE TIMELINESS, ACCURACY, RELIABILITY, COMPLETENESS, QUALITY OR CONTENT OF ANY SERVICES, INFORMATION OR MATERIALS PROVIDED THROUGH OR IN CONNECTION WITH THE USE OF THE SERVICE."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p5" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "None of Swiss Monkey, Swiss Monkey's affiliates or Swiss Monkey's licensors is responsible for the conduct, whether online or offline, between Offices and Professionals."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p8" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "None of Swiss Monkey, Swiss Monkey's affiliates or Swiss Monkey's licensors guarantee that any of Your personal information, including without limitation User Information provided by You, results on any Background Checks that Swiss Monkey and its affiliates and licensors conduct on You, as well as Ratings submitted by other Users about Your performance, whether accurate or not, will not be misappropriated, intercepted, deleted, destroyed, or used by others."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li4" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Indemnification"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p8" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "By using this Platform or our Services, You agree to indemnify, hold harmless and, at Swiss Monkey's option, defend Swiss Monkey and its officers, directors and agents from any claims, damages, losses, liabilities, and all costs and expenses of defense, including but not limited to attorneys' fees, resulting directly or indirectly from a claim by a third party that arises in connection with Your use of this Platform or Services or from the performance or non-performance of any Assignments by You or Your Counterparty."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li4" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Limitation of Liability"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p5" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey will make commercially reasonable efforts to secure its Platform from mischief, understanding, however, that Swiss Monkey may rely on information provided to it by Users and contained in their Profiles, and that mistakes and security breaches such as hacking can nonetheless occur. User acknowledges and agrees that Swiss Monkey will bear no liability to User for any matter or claim arising from the foregoing."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p5" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "IN NO EVENT SHALL Swiss Monkey BE LIABLE TO ANY USER OF THIS PLATFORM OR ANY OTHER PERSON OR ENTITY FOR ANY SPECIAL, INCIDENTAL, CONSEQUENTIAL, EXEMPLARY, OR OTHER INDIRECT DAMAGES, INCLUDING BUT NOT LIMITED TO DAMAGES FOR LOSS OF PROFITS, LOSS OF DATA, LOSS OF USE, OR COSTS OF OBTAINING SUBSTITUTE GOODS OR SERVICES ARISING OUT OF THE USE, INABILITY TO USE, UNAUTHORIZED ACCESS TO OR USE OR MISUSE OF THE PLATFORM OR ANY INFORMATION CONTAINED THEREON, WHETHER BASED UPON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), OR OTHERWISE, EVEN IF SWISS MONKEY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR LOSSES."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p8" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "YOU AGREE AND ACKNOWLEDGE THAT SWISS MONKEY\u2019S TOTAL CUMULATIVE LIABILITY IN CONNECTION WITH THESE TERMS OF SERVICE, THE WEBSITE, THE CONTENT, OR SERVICES REQUESTED OR RENDERED BETWEEN PROFESSIONAL AND OFFICE, WHETHER IN CONTRACT, TORT, OR OTHERWISE, SHALL NOT EXCEED $100.00."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li4" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Exclusions"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p8" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li9" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Third-Party Websites, Products, or Services"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Links to Third Party Websites"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "This Platform may contain links to non-Swiss Monkey websites or resources that are provided to you as a convenience. Any outside website accessed from the Website is independent from Swiss Monkey, and Swiss Monkey has no control over the content of such websites. Swiss Monkey is not responsible for the content of any linked website or for any loss or damage incurred in connection with your use of such links or dealings with the operators of such non-Swiss Monkey websites."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "No Implied Endorsements"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "In no event shall any reference to any third party or third party product or service be construed as an approval or endorsement by Swiss Monkey of that third party or of any product or service provided by a third party. Likewise, a link to a non-Swiss Monkey website does not imply that Swiss Monkey endorses or accepts any responsibility for the content or use of such website. Swiss Monkey does not endorse, warrant or guarantee any product or service offered by any third party through an online messaging service or link accessible through this Website and will not be a party to or in any way monitor any transaction involving any third party providers of products or services. As with the purchase of a product or service through any medium or in any environment, you are responsible for exercising appropriate judgment and caution."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li9" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Termination"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Termination by Swiss Monkey"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey may terminate any User's access to the Platform, in Swiss Monkey's sole discretion, for any reason and at any time, with or without prior notice. It is Swiss Monkey's policy to terminate Users who violate these Terms of Service, as deemed appropriate in Swiss Monkey's sole discretion, but Swiss Monkey may also terminate access as provided for in the preceding sentence. Swiss Monkey may terminate your access to the Website if you do not use Your Account for a lengthy period, as determined by Swiss Monkey from time to time in its sole discretion. You agree that Swiss Monkey is not liable to you or any third party for any termination of your access to the Website."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Termination by You"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "You may terminate Your Account at any time by deleting or de-activating Your Account. "
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Reactivation"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Provided that You deleted Your Account or You allowed Your Account to lapse by not using Your Account for a sufficiently long period, You may reactivate Your Account by following the process set forth by Swiss Monkey from time to time, during a time period established by Swiss Monkey from time to time following the deletion or deactivation of Your Account. If Your Account may no longer be reactivated, Swiss Monkey may, in its discretion, permit you to create a new account."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li4" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Agreement to Arbitrate"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Except if You opt-out or for disputes relating to Your or Swiss Monkey's intellectual property (such as trademarks, trade dress, domain names, trade secrets, copyrights and patents); You agree that all disputes between You and Swiss Monkey (whether or not such dispute involves a third party) arising out of or relating to these Terms of Service, the Services, and/or Privacy Policy shall be finally resolved by arbitration before a single arbitrator conducted in the English language in Sacramento, California, U.S.A. under the Commercial Arbitration Rules of the American Arbitration Association (AAA) and You and Swiss Monkey hereby expressly waive trial by jury. You and Swiss Monkey shall appoint as sole arbitrator a person mutually agreed by You and Swiss Monkey or, if You and Swiss Monkey cannot agree within thirty (30) days of either party's request for arbitration, such single arbitrator shall be selected by the AAA upon the request of either party. The parties shall bear equally the cost of the arbitration (except that the prevailing party shall be entitled to an award of reasonable attorneys' fees incurred in connection with the arbitration in such an amount as may be determined by the arbitrator). All decisions of the arbitrator shall be final and binding on both parties and enforceable in any court of competent jurisdiction. Notwithstanding this, application may be made to any court for a judicial acceptance of the award or order of enforcement. Notwithstanding the foregoing, Swiss Monkey shall be entitled to seek injunctive relief, security or other equitable remedies from the United States District Court for a district in California or any other court of competent jurisdiction. Under no circumstances shall the arbitrator be authorized to award damages, remedies or awards that conflict with these Terms of Use or to award punitive damages, including but not limited to pursuant to federal or state statutes permitting multiple or punitive awards. Any claims brought by you or Swiss Monkey must be brought in that party's individual capacity, and not as a plaintiff or class member in any purported class or representative proceeding. Neither You nor Swiss Monkey will participate in a class action or class-wide arbitration for any claims covered by these Terms of Service. You hereby waive any and all rights to bring any claims related to these Terms of Service and Privacy Policy as a plaintiff or class member in any purported class or representative proceeding. You may bring claims only on your own behalf. You may opt out of this Agreement to Arbitrate. If you do so, neither you nor Swiss Monkey can require the other to participate in an arbitration proceeding. To opt out, you must notify Swiss Monkey in writing within 30 days of the date that you first became subject to this arbitration provision. The opt-out notice must state that You do not agree to the Agreement To Arbitrate and must include Your name, address, phone number, Your Swiss Monkey account to which the opt-out applies and a clear statement that You want to opt out of this Agreement To Arbitrate. You must sign the opt-out notice for it to be effective. This procedure is the only way you can opt out of the Agreement To Arbitrate. You must use this address to opt out: Swiss Monkey, Inc. ATTN: Arbitration Opt-out, c/o Swiss Monkey INC, 1816 L Street, Sacramento, CA 95811. This Arbitration section will survive the termination of your relationship with Swiss Monkey."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "li",
	              { className: "li9" },
	              _react2.default.createElement(
	                "span",
	                { className: "s2" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Miscellaneous"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Jurisdictional Issues"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey makes no representations that information on this Platform is appropriate or available for use outside the United States. If you choose to access this Platform from outside the United States, You do so on your own initiative and at your own risk and you agree and acknowledge that you are responsible for complying with all applicable United States laws as well as your local laws and regulations. If You transact business through this Platform with a party that is located outside the United States, You agree and acknowledge that You do so voluntarily, that You are responsible for complying with all applicable United States laws as well as any local laws and regulations that may impact Your transaction, and You understand that Swiss Monkey disclaims all responsibility related to such transaction."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Severability"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "If any part of these Terms of Service is held to be unlawful, void, or unenforceable, that part will be deemed severable and shall not affect the validity and enforceability of the remaining provisions."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Entire Agreement"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p11" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "These Terms of Service constitute the entire agreement between, or, as appropriate, among, the Parties relating to the subject matter herein. Swiss Monkey may, at Swiss Monkey's sole discretion, revise these Terms of Service at any time by updating this posting and providing reasonable notice to you."
	            )
	          ),
	          _react2.default.createElement(
	            "ol",
	            { className: "ol1" },
	            _react2.default.createElement(
	              "ol",
	              { className: "ol2" },
	              _react2.default.createElement(
	                "li",
	                { className: "li10" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s2" },
	                  "Notices"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Please address all legal notices to\xA0info@swissmonkey.co"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p12" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "If You have any questions about these Terms of Service, please contact: contact@swissmonkey.io"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p5" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Copyright \xA9 2016, Swiss Monkey, INC. All Rights Reserved."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p14" },
	            "\xA0"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p15" },
	            _react2.default.createElement(
	              "span",
	              { className: "s1" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Privacy Policy"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Swiss Monkey knows that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly. This notice describes our Privacy Policy for the Swiss Monkey website and the services made available by Swiss Monkey through that website or through downloadable applications we make available to you (collectively, the \"Website\"). Capitalized terms used but not defined in this Privacy Policy shall have the meaning set forth in our Terms of Services. The Website provides a matching service so that Professionals seeking the opportunity to deliver professional services as an independent contractor can more easily find professional Offices that are looking for Professionals for temporary work Assignments."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "If you have questions or concerns regarding this Privacy Policy, you should contact Swiss Monkey's privacy contact by emailing us info@swissmonkey.co"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "This Privacy Policy covers only information that is collected through the Website and does not cover websites to which we link."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Notice of Information We Collect And How We Use It"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Our primary purpose in collecting and using Personal Information (as defined below) is to provide you with a safe, smooth, efficient, and customized experience in connection with our Website and Services. This allows us to provide services and features that most likely meet your needs, and to customize our service to make your experience safer and easier. We only collect Personal Information about you that we consider necessary for achieving this purpose. As used herein, \"Personal Information\" means information that specifically identifies an individual (such as name and address, e-mail address, telephone number, recent photographs, billing information, and professional licensure status) or other information about that individual that is directly linked to Personal Information. Personal Information does not include \"aggregate\" information, which is non-personally identifiable data we collect about the use of our Website and our Services. Personal Information includes information displayed in your Profile on our Website. While you have to use certain Personal Information for your Profile, your Profile is not displayed to the public apart from other Users. However, any information you choose to share in your Profile can be accessed by all other Users, and we cannot control how such Users may use such information."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "When you first launch our mobile or web application, you will be asked to allow the app access to your location. This information may be used to notify you, Swiss Monkey or other users, of your location or the speed at which your device is traveling. If you initially consent to our collection of location information, you can subsequently stop the collection of this information by changing the preferences on your mobile device. If you do so, certain features of our Services will no longer function. You may also stop our collection of location information by following the standard uninstall process to remove our Services from your device."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "We collect and store information, including Personal Information, that is voluntarily supplied to us by you when registering for the Website. You can choose not to provide us with certain information, but by doing so, you may not be able to take advantage of many of our features and functionality. We use Personal Information to deliver the Platform to you, to improve our Services, including advertising, and to develop analytics and aggregated data that allows us and affiliates of our Website (such as our advertisers) to use our Website. During registration, you are required to give truthful contact information (such as name and email address) in accordance with our Terms of Service available during registration. Once you give us your Personal Information, you are no longer anonymous to us."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "When you activate an account, we collect information such as your name, email address, social security number, password, and security questions and answers."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Information We Collect About Platform Visitors"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "We automatically track certain information based upon your use of the Platform. We use this information to do internal research on our users' demographics, interests, and behavior to better understand, protect and serve you and our community. By using our Platform or our services, you indicate your consent for Swiss Monkey and our affiliates to send cookies to your computer in order to uniquely identify your browser and improve the quality of our services; you may turn off cookies in your browser though, in doing so, some or all of our Services may not work. For a description of how cookies work, please see the section entitled \"Cookies\" below."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Log Files"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Like many Platforms, we may automatically gather certain information about our Platform traffic and store it in log files. This information includes Internet protocol (IP) addresses, browser type, Internet service provider (ISP), referring/exit pages, operating system, date/time stamp, and clickstream data. We may use this information, which does not identify individual users, to analyze trends, to administer the Platform, to track users' movements around the Platform and to gather demographic information about our user base. We do not link this automatically collected data to Personal Information. We may use a third-party tracking service that uses log files and cookies, see below, to track non- Personal Information about visitors to the Platform in the aggregate. This service captures usage and volume statistics to improve the usability of our Platform."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Cookies"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "A cookie is a small text file that is stored on a user's computer for record-keeping purposes. We may use cookies on this Website. As noted above, we do not link the information we store in cookies to any Personal Information you submit while on our Website. This Privacy Policy covers the use of cookies by the Website only and does not cover the use of cookies by any advertisers. We may use both session ID and persistent cookies. A session ID cookie expires when you close your browser. We may use session ID cookies to make it easier for you to navigate our Website. We may use cookies for managing your browser and mobile sessions for your convenience. A persistent cookie remains on your hard drive for an extended period of time. You can remove persistent cookies by following directions provided in your Internet browser. We may set a persistent cookie to store your password, so you do not have to enter it more than once. Persistent cookies also enable us to track and target the interests of our users to enhance the experience on our Website. If you reject cookies, you may still use our Platform, but your ability to use some areas of our Platform, such as placing or receiving Assignments or surveys, may be limited. Some of our business affiliates (e.g., sponsors, vendors) may use cookies on our Platforms. Additionally, we have no access to or control over these cookies used on third party websites or links. See \"Third Party Advertisers.\" The acceptance and storage of cookies can be managed through your web browser's security settings."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Clear Gifs (Web Beacons/Web Bugs)"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "We may, and our third party affiliates may, employ a software technology called clear gifs, also referred to as web beacons or web bugs, that help manage content on the Platform by tracking what content is effective. Clear gifs are tiny graphics with a unique identifier, similar in function to cookies, and are used to track the online movements of Platform users. In contrast to cookies, which are stored on a user's computer hard drive, clear gifs are embedded invisibly on Web pages and are about the size of the period at the end of this sentence. We do not tie the information gathered by clear gifs to our customers' Personal Information. We may use clear gifs in our HTML-based emails to let us know which emails recipients have opened. This allows us to gauge the effectiveness of certain communications and the effectiveness of our marketing campaigns. If you would like to opt-out of these emails, please see the process described below under the heading \"Choice and Opt-out.\" We may use embedded scripts, which are programming code that collects information about your interactions with the Website, such as the links you click on. The code is temporarily downloaded onto your computer or other device from our server or a third party provider and is deactivated or deleted when you disconnect from the Website. In addition, we may use a variety of other technologies that collect similar information for security and fraud detection purposes. You may have the option to provide demographic information (such as income level and preferred language of communication) to us."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Mobile Use"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "If you visit or use our Platform on a mobile device or use our mobile application, we may collect information from your device, including device ID and your mobile carrier. We may store and use that information for security purposes (for example, for user verification) and to improve your experience as a user of our Website and Services. Once you have established your account on your mobile device or computer, we may collect information we receive from your mobile device or computer, such as your device's type, number and the serial number of its chip. We also collect all payment card and transaction information, as described under \"Notice of Information We Collect And How We Use It\" above. Use of the Website on a mobile device may allow your mobile carrier or other access provider to view data that appears on the device as a result."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Information We Collect To Respond To your Choices and Requests"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Registration"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "In order to use some features of this Platform, you must first complete the registration form and create a user name and password. During registration, you are required to give truthful contact information (such as name, email address and phone number) in accordance with our Terms of Services. We use this information to contact you about the services on our Platform in which you have expressed interest."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Profile"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "If you choose to create a Profile on the Platform, we may collect other Users' Ratings about you."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Surveys, Contests or Promotions"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "We may provide you the opportunity to participate in surveys, contests or promotions on our Platform. If you participate, we will request certain Personal Information from you. The requested information typically includes contact information (such as name and shipping address) and demographic information. We use this information to notify contest winners and award prizes, to monitor Platform traffic, or to personalize the Platform (in the case of anonymous information collected in surveys) and to send participants an email newsletter."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "We may use a third party service provider to conduct these surveys, contests or promotions on our Platform. If we use a third party to do so, a link to the third party's Privacy Policy will appear in the window that opens for the survey, contest or promotion, and you are now subject to that third party's Privacy Policy. If you have any questions or concerns regarding how such third parties use your information, please consult the applicable third party's Privacy Policy. You agree that we will not be responsible or liable for any loss or damage incurred in connection with our affiliation with such third parties, their activities on our Website, and the sharing of your information with such third parties. If you do not see a link to a Privacy Policy in a survey, contest or promotion window that pops up automatically or opens when you click on a link, or if you fill out a survey, contest or promotion form on our website that appears on a main page without a separate Privacy Policy link, our Privacy Policy applies."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Communication from Us or the Website"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Newsletters"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Users may receive newsletter(s) or offers that may be of value to their professional efforts. Out of respect for your privacy, we provide you a way to unsubscribe. Please see the \"Choice and Opt-out\" section below."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Service-Related Announcements"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "We may send you service-related announcements when it is necessary to do so. For instance, if our service is temporarily suspended for maintenance, we might send you an email. Generally, you may not opt-out of these communications, which are not promotional in nature. If you do not wish to receive them, you have the option to deactivate your account."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Customer Service"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Based upon the Personal Information you provide us, we may send you a welcoming email to verify your username and password. We will communicate with you in response to your inquiries, to provide the services you request, and to manage your account. We will communicate with you by email telephone, text messages or through push notifications, in accordance with your wishes. You may contact customer service at contact@swissmonkey.io."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p7" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Conditions Under Which We Share Information"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Aggregate Information (Non-Personally Identifiable)"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "We may share aggregated demographic information about our user base with our affiliates and advertisers. This information does not identify individual users."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "We do not link aggregate user data with Personal Information. Your contributions or notes to a module, forum or other service on the Website (\"Contribution\") may also be aggregated and made publicly available. Your Contributions may be aggregated according to their registration and login status."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Personal Information"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Except as discussed in this Privacy Policy, we do not share Personal Information with third parties. If you are a Professional, we may share your Personal Information with an Office that is looking for Professionals of your type for an Assignment. If you are an Office, we may share your Personal Information with a Professional that is looking for Assignments that you are likely to offer. "
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Agents"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "We may use a credit card processing company to bill you for Services. These companies do not retain, share, store or use Personal Information for any other purposes. Your interaction with any third party payments service is subject to the terms and conditions provided by such third party."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Third Party Advertisers"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "The ads appearing on this Platform are delivered to Users by our advertising affiliates. We may share Website usage information about users with our advertising affiliates for the purpose of targeting our Internet banner advertisements on this Website."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Our advertising affiliates may use cookies and clear GIFs on the Platform, which allow them to recognize a user's cookie when a user visits the Website. The information that our advertising affiliates collect and share through this technology is not personally identifiable."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "For more information about our third-party advertisers, or to learn more about the choices available to you regarding this anonymous information, please contact contact@swissmonkey.io"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Legal Disclaimer"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "We reserve the right to disclose your Personal Information as required by law and when we believe that disclosure is necessary to protect our rights; to comply with a judicial proceeding, court order, or legal process served on us or the Platform; or in connection with an actual or proposed corporate transaction or insolvency proceeding involving all or substantially all of our business or assets related to the Services."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Choice and Opt-out"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "We provide you the opportunity to 'opt-out' of having your Personal Information used for certain purposes, when we ask for this information. For example, if you request or provide an Assignment, but do not wish to receive any additional marketing material from us, you can email us at ",
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "mailto:contact@swissmonkey.io" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s9" },
	                  "contact@swissmonkey.io"
	                )
	              ),
	              ". We may also provide non-personally identifiable information or aggregated information that does not identify you, to other parties for marketing, advertising, or other uses. If you no longer wish to receive our newsletter and promotional communications, you may opt-out of receiving them sending an email to contact@swissmonkey.io. "
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "You will be notified when your Personal Information is collected by any third party that is not our agent/service provider other than a Counterparty, so you can make an informed choice as to whether or not to share your information with that party."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Links to Other Websites"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "The Platform may contains links to other websites that are not owned or controlled by Swiss Monkey. Please be aware that we are not responsible for the privacy policies of such other websites. We encourage you to be aware when you leave the Website and to read the privacy policies of each and every website that collects Personal Information. This Privacy Policy applies only to information collected by our Website and through our Services."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Access to Personal Information"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "If your Personal Information changes, or if you no longer desire our service, you may correct, update or deactivate it by making the change on your profile or contacting Swiss Monkey. Please keep in mind that whenever you voluntarily make your Personal Information or other private information available for viewing by third parties online - for example on blogs, discussion forums, or other community posting or social networking websites - that information can be seen, collected and used by others besides us. We cannot be responsible for any unauthorized third-party use of such information."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Information Security"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "The security of your Personal Information is important to us. When you enter sensitive information (such as credit card number and/or social security number) on our registration or order forms, we encrypt that information using secure socket layer technology (SSL)."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "We follow generally accepted industry standards to protect the Personal Information submitted to us, both during transmission and once we receive it. No method of transmission over the Internet, or method of electronic storage, is 100% secure, however. Therefore, while we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security. If you have any questions about security on our Website, you can email us at ",
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "mailto:contact@swissmonkey.io" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "s9" },
	                  "contact@swissmonkey.io"
	                )
	              ),
	              ". "
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Children Under 13 and Teens (Persons 13 to 17 Years of Age)"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Our Website is not directed to people under 18 years of age. If you become aware that your child has provided us with Personal Information without your consent, please contact us at contact@swissmonkey.io. We do not knowingly collect Personal Information from children under 18. If we become aware that a child under 18 has provided us with Personal Information, we take steps to remove that information and terminate the applicable account."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Terms of Service"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Please also visit our Terms of Service section establishing the use, disclaimers, and limitations of liability governing the use of our Website."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Your Consent"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "By using the Platform or our Services, you consent to the current version of our Privacy Policy."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Changes to our Privacy Policy"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p3" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "If we decide to change our Privacy Policy, we will post changes to this Privacy Policy and other places we deem appropriate so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we disclose it. We reserve the right to modify this Privacy Policy at any time, and such change will apply with respect to information you provide or your activity on the Website after the change in policy, so please review it frequently. If we make changes that materially affect our uses or disclosures of Personal Information that we have previously collected, we will contact you here, by email, or by means of a notice on our home page to obtain your consent to have the changes to our Privacy Policy apply retroactively."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p10" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Contact Us"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "If you have any questions or suggestions regarding our Privacy Policy, please contact us at contact@swissmonkey.io"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p2" },
	            _react2.default.createElement(
	              "span",
	              { className: "s2" },
	              "Effective Date:\xA0May 1, 2018"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Terms;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-terms-js-8242825181ea07ec4625.js